var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.624 3.351a.75.75 0 0 1 .748-.002l7 4a.75.75 0 0 1 0 1.302l-7 4A.75.75 0 0 1 3.25 12V4a.75.75 0 0 1 .374-.649z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export default ForwardRef;